import React, { useCallback, useEffect, useState } from "react";
import { useRef } from "react";
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem,
} from "@/components/organisms/forms/select";
import { Label } from "@/components/atoms/texts/label";
import { Input } from "@/components/ui/input";
import { useFormEditBills } from "./useFormEditBills";
import FormIsSend from "@/components/organisms/feedback/formIsSend";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import useConsultant from "@/components/organisms/navigation/MenuConsultant/useConsultant";
import { useConsultantContext } from "@/context/ConsultantContext";
import { useAppData } from "@/hooks/global-hooks/AppDataContext";
import { useDeleteConsultantInvoice } from "@/services/admin-services/mutations/useDeleteConsultantInvoice";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@/components/molecules/buttons/button";
import { Separator } from "@/components/atoms/divider/separatorShadcn";
import { useToast } from "@/components/organisms/feedback/use-toast";
import { Switch } from "@/components/ui/switch";
import PrintWarningMessage from "@/components/organisms/feedback/PrintWarningMessagee";
import getCurrencySymbolFromCode from "@/utils/getCurrencySymbolFromCode";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

export default function FormEditBills({ global = false, disabledDeletion, submitRef, onSubmit, editData, submissionSuccess = false, submissionError = false, setChangeContent }) {

    const { activeUser } = useConsultantContext();
    const { usersFormated } = useConsultant();
    const [confirmDelete, setConfirmDelete] = useState(false);
    const { toast } = useToast();
    const scrollContainerRef = useRef(null);
    const [t] = useTranslation("global");


    const nameInUserFormated = activeUser && activeUser.uuid;

    // Remplace l'ancien hook par le contexte
    const { loadingCurrencies, errorCurrencies, currencies } = useAppData();
    const { deleteConsultantInvoice, loading: loadingDelete, error: errorDelete, data: dataDelete } = useDeleteConsultantInvoice();

    const {
        consultantUuid,
        customer,
        billNumber,
        days,
        amountClient,
        amountConsultant,
        currency,
        tJMClient,
        tJMConsultant,
        periodStart,
        periodEnd,
        invoiceDate,
        paymentDate,
        commission,
        defaultValues,
        consultantUuidError,
        customerError,
        billNumberError,
        daysError,
        amountClientError,
        amountConsultantError,
        currencyError,
        tJMClientError,
        tJMConsultantError,
        periodStartError,
        periodEndError,
        invoiceDateError,
        paymentDateError,
        commissionError,
        formIsValid,
        setConsultantUuid,
        setCustomer,
        setBillNumber,
        setDays,
        setAmountClient,
        setAmountConsultant,
        setCurrency,
        setTJMClient,
        setTJMConsultant,
        setPeriodStart,
        setPeriodEnd,
        setInvoiceDate,
        setPaymentDate,
        setCommission,
        manualCommission,
        setManualCommission,
        calculateDefaultCommission,
        validateForm,
        resetForm,
        useDefaultValues,
    } = useFormEditBills(editData, nameInUserFormated);
    const symbol = getCurrencySymbolFromCode(currency)

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const calculatedCommission = calculateDefaultCommission(days, tJMConsultant);
        // console.log("handleSubmit defaultValues = ", defaultValues);
        // console.log("manual commisssion", manualCommission, "commission", commission, "calculated", calculatedCommission)
        if (validateForm("all")) {
            onSubmit({
                consultantUuid,
                customer,
                billNumber,
                days,
                amountClient,
                amountConsultant,
                currency,
                tJMClient,
                tJMConsultant,
                periodStart,
                periodEnd,
                invoiceDate,
                paymentDate,
                commission : (manualCommission === false) ? calculatedCommission : commission,
                manualCommission
            });
        }
        scrollToTop();
    },[calculateDefaultCommission, manualCommission, commission, days, consultantUuid, customer, billNumber, amountClient, amountConsultant, currency, tJMClient, tJMConsultant, periodStart, periodEnd, invoiceDate, paymentDate, validateForm, onSubmit]);

    const [allCurrencies, setAllCurrencies] = useState();

    useEffect(() => {
        currencies && setAllCurrencies(currencies);
    }, [currencies]);

    useEffect(() => {
        if (!editData && submissionSuccess) {
            resetForm();
        }
    }, [submissionSuccess]);

    const handleDeleteInvoice = (invoiceUuid) => {
        // console.log("invoiceUuid = ", invoiceUuid);
        deleteConsultantInvoice(invoiceUuid);

        setConfirmDelete(false);
    }
    useEffect(() => {
        // console.log("dataDelete", dataDelete)
        if (dataDelete) {
            setChangeContent();
            // refetchFromScratch(1)
        }
    }, [dataDelete])

    const scrollToTop = () => {
        // importer le hook useRef : import {useRef} from "react";
        // Déclarer la ref :     const scrollContainerRef = useRef(null);
        // ajouter au contenant : className="h-full overflow-auto" ref={scrollContainerRef}
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0; // Définit la position de défilement à 0 pour remonter en haut
        }
    };

    return (
        <div className="w-full h-full overflow-auto mb-8" ref={scrollContainerRef} >
            {submissionSuccess && !submissionError && <FormIsSend message={editData ? `success.changesSaved` : `success.c`} />}
            {submissionError && <PrintErrorMessage error={submissionError} />}

            <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4 h-full " >
                {/* Consultant */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.companyBenefits.consultant" />
                    <Select value={consultantUuid} onValueChange={(value) => setConsultantUuid(value)}>
                        <SelectTrigger
                            className={`col-span-3 p-2 border rounded-md text-body bg-white ${consultantUuidError === true && `border-error`
                                } ${consultantUuidError === false && `border-success`} ${consultantUuidError == null && `border-greyStrong`
                                }`}
                        >
                            <SelectValue placeholder={<Label message="global.actions.select" />} />
                        </SelectTrigger>
                        <SelectContent>
                            <>
                                {global
                                    ? usersFormated && usersFormated.map((user) => (
                                        <SelectItem key={user.uuid} value={user.uuid}>{user.trigram + " " + user.firstname + " " + user.lastname}</SelectItem>
                                    ))
                                    : activeUser &&
                                    <SelectItem value={activeUser.uuid}>{activeUser.trigram + " " + activeUser.firstname + " " + activeUser.lastname}</SelectItem>

                                }
                            </>
                        </SelectContent>
                    </Select>
                </div>

                {/* Customer */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.customer" />
                    <Input
                        value={customer}
                        onChange={(e) => setCustomer(e.target.value)}
                        onBlur={() => validateForm("customerErrorTest")}
                        className={`col-span-3 p-2 border rounded-md  ${customerError === true && `border-error`
                            } ${customerError === false && `border-success`} ${customerError == null && `border-greyStrong`
                            }`
                        }
                    />
                    {customerError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Bill Number */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.billNumber" />
                    <Input
                        value={billNumber}
                        onChange={(e) => setBillNumber(e.target.value)}
                        onBlur={() => validateForm("billNumberErrorTest")}
                        className={`col-span-3 p-2 border rounded-md ${billNumberError === true && `border-error`
                            } ${billNumberError === false && `border-success`} ${billNumberError == null && `border-greyStrong`
                            }`
                        }
                    />
                    {billNumberError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Invoice Date */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.invoiceDate" />
                    <Input
                        type="date"
                        value={invoiceDate}
                        onChange={(e) => setInvoiceDate(e.target.value)}
                        onBlur={() => validateForm("invoiceDateErrorTest")}
                        className={`col-span-3 p-2 border rounded-md ${invoiceDateError === true && `border-error`
                            } ${invoiceDateError === false && `border-success`} ${invoiceDateError == null && `border-greyStrong`
                            }`}
                    />
                    {invoiceDateError && <Label message="error.mandatory" color="error" />}
                </div>
                {/* Payment Date */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.paymentDate" />
                    <Input
                        type="date"
                        value={paymentDate}
                        onChange={(e) => setPaymentDate(e.target.value)}
                        // onBlur={() => validateForm("paymentDateErrorTest")} // plus besoin de validation
                        className={`col-span-3 p-2 border rounded-md ${paymentDateError === true && `border-error`
                            } ${paymentDateError === false && `border-success`} ${paymentDateError == null && `border-greyStrong`
                            }`}
                    />
                    {/* Pas d'erreur affichée car optionnel */}
                </div>
                {/* Period Start */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.prospectConsultantPanel.formPlaceHolder.startDate" />
                    <Input
                        type="date"
                        value={periodStart}
                        onChange={(e) => setPeriodStart(e.target.value)}
                        onBlur={() => validateForm("periodStartErrorTest")}
                        className={`col-span-3 p-2 border rounded-md ${periodStartError === true && `border-error`
                            } ${periodStartError === false && `border-success`} ${periodStartError == null && `border-greyStrong`
                            }`}
                    />
                    {periodStartError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Period End */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.prospectConsultantPanel.formPlaceHolder.endDate" />
                    <Input
                        type="date"
                        value={periodEnd}
                        onChange={(e) => setPeriodEnd(e.target.value)}
                        onBlur={() => validateForm("periodEndErrorTest")}
                        className={`col-span-3 p-2 border rounded-md ${periodEndError === true && `border-error`
                            } ${periodEndError === false && `border-success`} ${periodEndError == null && `border-greyStrong`
                            }`}
                    />
                    {periodEndError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Days */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.days" />
                    <Input
                        type="number"
                        value={days}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => setDays(e.target.value)}
                        onBlur={() => validateForm("daysErrorTest")}
                        className={`col-span-3 p-2 border rounded-md ${daysError === true && `border-error`
                            } ${daysError === false && `border-success`} ${daysError == null && `border-greyStrong`
                            }`}
                    />
                    {daysError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Currencies */}
                <div className='grid grid-cols-4 items-center gap-secondDegree w-full'>
                    <Label fontWeight="bold" className="col-span-1" message="consultants.expense.currency" />
                    {/* {errorCurrencies ? <PrintErrorMessage error={errorCurrencies} className={'col-span-3'} /> : */}
                    <Select className="" value={currency} onValueChange={(e) => { setCurrency(e) }} onBlur={() => validateForm("currencyErrorTest")}                       >
                        <SelectTrigger className={`col-span-3 p-2 bg-white border border-greyStrong text-body `}>
                            <SelectValue placeholder="Currency" />
                        </SelectTrigger>
                        <SelectContent >
                            {/* {loadingCurrencies ? <span className='loader' /> :  */}
                            {allCurrencies?.map((cur, index) => (
                                <SelectItem key={index} value={cur.code}>
                                    <Label >{cur.code + " " + cur.symbol}</Label>
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    {/* } */}
                </div>

                {/* Daily Rate Client */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.overview.dailyRateClient" />
                    <Input
                        type="number"
                        value={tJMClient}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => setTJMClient(e.target.value)}
                        onBlur={() => validateForm("tJMClientErrorTest")}
                        className={`col-span-3 p-2 border rounded-md 
                            ${tJMClientError === true && `border-error`
                            } ${tJMClientError === false && `border-success`} ${tJMClientError == null && `border-greyStrong`
                            }`}
                    />
                    {tJMClientError && <Label message="error.mandatory" color="error" />}
                </div>

                {/* Daily Rate Consultant */}
                <div className="grid grid-cols-4 items-center gap-2 w-full relative">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.overview.dailyRateConsultant" />
                    <Input
                        type="number"
                        value={tJMConsultant}
                        onChange={(e) => setTJMConsultant(e.target.value)}
                        onBlur={() => validateForm("tJMConsultantErrorTest")}
                        onWheel={(e) => e.target.blur()}
                        className={`col-span-3 p-2 border rounded-md ${tJMConsultantError === true && `border-error`
                            } ${tJMConsultantError === false && `border-success`} ${tJMConsultantError == null && `border-greyStrong`
                            }`}
                    />
                    <div className="absolute px-firstDegree pb-1 rounded-sm flex hover:bg-hover hover:cursor-pointer right-firstDegree" onClick={() => useDefaultValues("dailyRateConsultant")}>
                        <Label size="caption" color="primaryStrong" fontWeight="bold" className="hover:cursor-pointer" message="global.actions.useDefault">Use default</Label>
                    </div>
                    {tJMConsultantError && <Label message="error.mandatory" color="error" />}
                </div>
                {/* Warning manual commission */}
                {manualCommission && <PrintWarningMessage warning="consultants.statement.billsDetails.manualCommissionWarning" />}
                {/* Commission Is Auto */}
                <div className="grid grid-cols-4 items-center gap-2 w-full relative">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.manualCommission" />
                    <div className="col-span-3 flex items-center gap-2">
                        <Switch
                            checked={manualCommission ===true}
                            onCheckedChange={(value) => setManualCommission(value)}
                        />
                        <Badge
                            variant={manualCommission ? "warning" : "success"}
                            className="w-auto max-w-[150px] px-3 min-h-6 h-auto "
                            size="bodySmall"
                            text={manualCommission ? t("consultants.statement.billsDetails.manual") : t("consultants.statement.billsDetails.auto")}
                        />
                    </div>
                </div>
                {/* {manualCommission && console.log(manualCommission, "manual commission in form")} */}
                {/* Explication calcul automatique */}
                { (
                    <div className="flex items-start gap-2 w-full bg-information20 p-3 rounded-sm ">
                        <Label fontWeight="bold" className="col-span-1 text-primary" message="consultants.statement.billsDetails.calculationMethod" />
                        <div className="col-span-3 flex flex-col gap-1">
                            <Label size="body" className="text-primaryStrong">
                                {manualCommission === false
                                    ? `${days || 0} jours × ${defaultValues?.defaultCommissionPerWorkingDay || 0}€ + ${tJMConsultant || 0}€ × ${defaultValues?.defaultCommissionPerMonthInDailyRate || 0} = ${calculateDefaultCommission(days, tJMConsultant).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}€`
                                    : `${days || 0} jours × ${defaultValues?.dailyCommissionEur || 0}€ + ${defaultValues?.monthlyCommissionEur || 0}€ = ${calculateDefaultCommission(days, tJMConsultant).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}€`}
                            </Label>
                        </div>
                    </div>
                )}
                {/* Commission */}
                {manualCommission && (
                    <div className="grid grid-cols-4 items-center gap-2 w-full relative">
                        <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.commission" />
                        <Input
                            type="number"
                            value={commission}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => setCommission(e.target.value)}
                            onBlur={() => validateForm("commissionErrorTest")}
                            className={` col-span-3 p-2 border rounded-md ${commissionError === true && `border-error`
                                } ${commissionError === false && `border-success`} ${commissionError == null && `border-greyStrong`
                                }`}
                        />
                        <div className="absolute px-firstDegree pb-1 rounded-sm flex hover:bg-hover hover:cursor-pointer right-firstDegree" onClick={() => useDefaultValues("commission")}>
                            <Label size="caption" color="primaryStrong" fontWeight="bold" className="hover:cursor-pointer" message="global.actions.useDefault">Use default</Label>
                        </div>
                    </div>
                )}

                {/* Amount Client */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.amountCustomer" />
                    <Input
                        type="number"
                        disabled
                        onWheel={(e) => e.target.blur()}
                        value={amountClient}
                        // onChange={(e) => setAmountClient(e.target.value)}
                        className={`col-span-3 p-2 border rounded-md ${amountClientError && "border-error"
                            }`}
                    />
                </div>

                {/* Amount Consultant */}
                <div className="grid grid-cols-4 items-center gap-2 w-full">
                    <Label fontWeight="bold" className="col-span-1" message="consultants.statement.billsDetails.amountConsultant" />
                    <Input
                        type="number"
                        value={amountConsultant}
                        onWheel={(e) => e.target.blur()}
                        disabled
                        // onChange={(e) => setAmountConsultant(e.target.value)}
                        className={`col-span-3 p-2 border rounded-md ${amountConsultantError && "border-error"
                            }`}
                    />
                </div>




                {errorDelete}
                {errorDelete && <PrintErrorMessage error={errorDelete} />}
                {!disabledDeletion && <Separator />}
                {!disabledDeletion && (confirmDelete ?
                    <div className="flex flex-col gap-firstDegree">
                        <Label message="global.actions.askConfirmDelete" />
                        <Button
                            text="global.actions.confirmDelete"
                            onClick={() => handleDeleteInvoice(editData.uuid)}
                            className="text-white bg-error font-bold hover:bg-destructive " />
                        <Button
                            text="global.actions.cancel"
                            style="ghost"
                            onClick={() => setConfirmDelete(false)}>
                        </Button>
                    </div> :
                    <Button
                        style="outline"
                        text="global.actions.delete"
                        onClick={() => setConfirmDelete(true)}
                        className="text-error border border-error font-bold hover:bg-error20"
                        showLeftIcon
                        leftIcon={<DeleteIcon />}>

                    </Button>)
                }



                {/* <div className="flex justify-end">
          <button type="submit" className="btn-primary">
            <Label message="global.actions.submit" />
          </button>
        </div> */}
                <Input type='submit' className='hidden' ref={submitRef} />

            </form>
        </div>
    );
}
